import { SET_AUTH } from './ActionTypes';
import { msalInstance, ensureMsalInitialized } from './AuthProvider';

export function setAuth(data) {
  return {
    type: SET_AUTH,
    payload: data,
  };
}

export function getAuth() {
  return async (dispatch) => {
    try {
      // Ensure MSAL is initialized before calling any methods
      await ensureMsalInitialized();

      const accounts = msalInstance.getAllAccounts();

      if (accounts.length > 0) {
        const account = accounts[0];
        dispatch(
          setAuth({
            Authenticated: true,
            Authorised: true,
            user: account.username,
          })
        );
      } else {
        dispatch(
          setAuth({
            Authenticated: null,
            Authorised: null,
            user: null,
          })
        );
      }
    } catch (error) {
      console.error('Error in getAuth:', error);
      dispatch(
        setAuth({
          Authenticated: null,
          Authorised: null,
          user: null,
        })
      );
    }
  };
}
